import { render, staticRenderFns } from "./zhengce.vue?vue&type=template&id=7a6df60b&"
import script from "./zhengce.vue?vue&type=script&lang=js&"
export * from "./zhengce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports